import React from 'react';
import {connectWithCore} from 'framework/hocs';
import ruleSet from 'framework/validation/rules';
import contentMap from 'componentLibrary';
import REST from 'go/requests/rest';
import {DynamicActionButton as _DynamicActionButton} from 'app-ui-componentlibrary/dist/componentLibrary/form/DynamicActionButton';

export const DynamicActionButton = (props) => {
  const createEntity = async (entityType) => {
    const {token, grantId, subGrantId} = props;
    let createEntityRequest = 'createEntity';
    let id = grantId;
    if (subGrantId && props.entityType === 'subGrant') {
      if (entityType === 'amendment') {
        entityType = 'subAmendmentRecommendation';
      }
      createEntityRequest = 'createEntityFromSubGrant';
      id = subGrantId;
    }
    return REST.dynamicData[createEntityRequest](token, id, entityType)
      .then(REST.handler.handleResponse)
      .then((entityData) => {
        if (entityData.errors == null) {
          return entityData;
        }
      });
  };
  return (
    <_DynamicActionButton
      {...props}
      {...{ruleSet}}
      {...{contentMap}}
      createEntity={createEntity}
    />
  );
};
export default connectWithCore(DynamicActionButton);
